import React, { useContext, useEffect, useMemo, useRef, useState } from "react";

import styles from "./Main.module.css";

import { Button, Card, Checkbox, Collapse, Form, Input } from "antd";
import { AppContext } from "../App.context";
import axios from "axios";
import {
  checkEmpty,
  getAboteOpenUtil,
  getAboutLot,
  getCheckHeveGetNew,
  getUpdateLog,
} from "../service/util.service";
import { json, useNavigate } from "react-router-dom";
import PrivateRoute from "../menu/PrivateRoute";
import MenuTop from "../menu/MenuTop";
import MenuLett from "../menu/Menu";
import CardLot from "../card/CardLot";

function Main(props) {
  return (
    <>
      <MenuLett />
      <div className={styles.boxMain}>
        <MenuTop />
        <Content />
      </div>
    </>
  );
}

function Content(props) {
  const [lots, setLots] = useState([]);
  const [lotTypes, setLotTypes] = useState([]);

  const reflectorLots = (lots) => {
    let lotuses = [];
    for (let a = 0; a < lots.length; a++) {
      let aboutOpen = getAboteOpenUtil(lots[a]);
      let data = lots[a];
      data.time = aboutOpen.time;
      data.status = aboutOpen.status;
      lotuses.push(data);
    }

    lotuses.sort(function (a, b) {
      var keyA = a.time,
        keyB = b.time;
      // Compare the 2 dates
      if (keyA < keyB) return -1;
      if (keyA > keyB) return 1;
      return 0;
    });

    let lots1 = lotuses.filter((lot) => lot.status == true);
    let lots2 = lotuses.filter((lot) => lot.status == false);
    lotuses = Object.assign([], lots1.concat(lots2));

    // console.log("lots1", lots1);
    // console.log("lots2", lots2);
    // console.log("lotuses", lotuses);
    return lotuses;
  };
  const loaderData = async () => {
    // let havegetnew = await getCheckHeveGetNew();
    let havegetnew = false;

    let aboutLot = null;
    if (!checkEmpty(localStorage.getItem("aboutLot")) && havegetnew == false) {
      aboutLot = JSON.parse(localStorage.getItem("aboutLot"));
      setLotTypes(aboutLot.lotTypes);
      let lotsuse = reflectorLots(aboutLot.lots);
      setLots(lotsuse);
    } else {
      try {
        aboutLot = await getAboutLot();
        console.log("aboutLot", aboutLot);
        setLotTypes(aboutLot.lotTypes);
        let lotsuse = reflectorLots(aboutLot.lots);
        localStorage.setItem("aboutLot", JSON.stringify(aboutLot));
        setLots(lotsuse);
      } catch (e) {}
    }
  };

  useEffect(() => {
    loaderData();
  }, []);

  return (
    <div style={{ paddingTop: "60px" }}>
      <div className={styles.headerTypeResualtMobile}>ลงหวย</div>
      {/* <div className={styles.boxLotAllPc}>
        {lotTypes.map((type) => {
          return (
            <div>
              <div className={styles.headerType}>{type.lot_type}</div>
              <div className={styles.boxLot}>
                {lots
                  .filter((lot) => lot.lot_type == type.lot_type)
                  .map((lot) => {
                    return (
                      // <div className={styles.boxLotItem}>{lot.lot_name}</div>
                      <CardLot lot={lot}></CardLot>
                    );
                  })}
              </div>
            </div>
          );
        })}
      </div> */}

      <div className={styles.boxLotAllPc}>
        {lotTypes.map((type) => {
          return (
            <div className={styles.boxMainLot}>
              <Collapse
                className={styles.CollapseMobileLot}
                defaultActiveKey={"1"}
                items={[
                  {
                    key: "1",
                    label: type.lot_type,
                    children: (
                      <div className={styles.boxLotMobile}>
                        {lots
                          .filter((lot) => lot.lot_type == type.lot_type)
                          .map((lot) => {
                            return (
                              // <div className={styles.boxLotItem}>{lot.lot_name}</div>
                              <CardLot lot={lot}></CardLot>
                            );
                          })}
                      </div>
                    ),
                  },
                ]}
                onChange={(e) => {}}
              />
            </div>
          );
        })}
      </div>

      <div className={styles.boxLotAllMobile}>
        {lotTypes.map((type) => {
          return (
            <div className={styles.boxMainLot}>
              <Collapse
                className={styles.CollapseMobileLot}
                items={[
                  {
                    key: "1",
                    label: type.lot_type,
                    children: (
                      <div className={styles.boxLotMobile}>
                        {lots
                          .filter((lot) => lot.lot_type == type.lot_type)
                          .map((lot) => {
                            return (
                              // <div className={styles.boxLotItem}>{lot.lot_name}</div>
                              <CardLot lot={lot}></CardLot>
                            );
                          })}
                      </div>
                    ),
                  },
                ]}
                onChange={(e) => {}}
              />
            </div>
          );
        })}
      </div>

      <div
        style={{ paddingBottom: "50px", paddingTop: "20px" }}
        className={styles.backToTopDiv}
      >
        <Button
          onClick={() => {
            window.scrollTo(0, 0);
          }}
          className={styles.backToTop}
        >
          Back To Top
        </Button>
      </div>
    </div>
  );
}
export default Main;
